import { Skeleton } from "@/components/skeleton";

export function SearchLoadingSkeleton() {
  return (
    <div className="flex flex-col px-xl py-lg">
      <div className="flex gap-2 pb-lg">
        <Skeleton className="h-4 w-4" />
        <Skeleton className="h-4 w-18" />
      </div>
      {[1, 2, 3].map((i) => (
        <div className="flex flex-col gap-xs py-md" key={i}>
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      ))}
    </div>
  );
}
